/**
 * Signature avancée par clé : « Continuer sur mon téléphone » (Franck,
 * 20/10/2026, après son essai depuis son PC : la clé était dans son iPhone,
 * rien ne l'avait dit avant, et Chrome n'a montré aucun QR code).
 *
 * Sur ordinateur, un QR code ouvre le MÊME lien sur le téléphone : lecture,
 * emplacements et visuel sont enregistrés côté serveur, rien n'est à refaire.
 * Sur téléphone ou tablette, tout se fait sur place.
 */
import { useEffect, useState } from "react";

import { Ico } from "./Icone";

/** Ordinateur = ni téléphone ni tablette. iPadOS se présente comme un Mac :
 *  on le reconnaît à son écran tactile. Un PC tactile garde un pointeur fin
 *  (souris, pavé), il reste un ordinateur. */
export function surOrdinateur(): boolean {
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod|Android|Mobile/i.test(ua)) return false;
  if (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) return false;
  return !window.matchMedia("(pointer: coarse)").matches;
}

export function SurTelephone({ ici, onIci }: {
  /** Libellé du lien discret pour rester sur l'ordinateur. */
  ici: string;
  onIci: () => void;
}) {
  const [image, setImage] = useState<string | null>(null);
  useEffect(() => {
    // Le QR code est dessiné ICI, dans le navigateur : l'adresse porte le
    // jeton du lien de signature et ne part chez aucun service tiers. Le
    // chemin seul (/sign/<jeton>), sans requête ni ancre.
    const lien = window.location.origin + window.location.pathname;
    // Dessiné en 480 px, affiché en 240 : net sur les écrans haute densité.
    // Chargé à la demande : seuls les ordinateurs en signature par clé en ont besoin.
    import("qrcode")
      .then((q) => q.default.toDataURL(lien, { width: 480, margin: 1, color: { dark: "#16324f", light: "#ffffff" } }))
      .then(setImage, () => setImage(null));
  }, []);

  return (
    <div className="sur-telephone">
      <div className="sur-telephone__qr">
        {image
          ? <img src={image} width={240} height={240} alt="QR code qui ouvre ce lien de signature sur votre téléphone" />
          : <div className="spinner" role="status" aria-label="Préparation du QR code" />}
      </div>
      <p className="sur-telephone__consigne">
        <Ico nom="telephone" /> Scannez avec l'appareil photo de votre téléphone
      </p>
      <p className="sur-telephone__note">
        Ce lien s'ouvre sur votre téléphone là où vous en êtes : ce que vous avez déjà fait est conservé.
      </p>
      <button type="button" className="btn btn--discret" onClick={onIci}>{ici}</button>
    </div>
  );
}
